module.exports = __webpack_public_path__ + "images/background/upload/active-1b6837b19ba71c1d8649df218e73a03c.png";